<template>
  <div>
    <p>
      <strong>{{$t('contract.sickness.headline') }}</strong>
    </p>
    <p>{{$t('contract.sickness.paragraphs.first') }}</p>
    <p>{{$t('contract.sickness.paragraphs.second') }}</p>

    <p v-if="sickness.name">
      {{$t('contract.sickness.contact.name') }}
      <span class="user-output">{{ sickness.name }}</span>
    </p>
    <p v-if="sickness.phone">
      {{$t('contract.sickness.contact.phone') }}
      <span class="user-output">{{ sickness.phone }}</span>
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
      sickness() {
        return this.$store.state.contract.sickness;
      },
    }
};
</script>